export enum OnboardingPlanningStep {
  TOUR = 'TOUR',
  ADD_ITEM = 'ADD_ITEM',
  VIEW_DETAILS = 'VIEW_DETAILS',
  DRAG_AND_DROP = 'DRAG_AND_DROP'
}
